import { RelevantExecution } from 'app/library/program-item/models/relevant-execution.model';
import { GlobalParticipant } from 'app/projects/user/src/lib/models/participant.model';
import { IParticipantBookingQuery } from '../interfaces/participant-booking.query.interface';

export class ParticipantBooking {
    user: GlobalParticipant;
    relevantExecutions: RelevantExecution[];

    constructor(participantBookingQuery: IParticipantBookingQuery) {
        if (participantBookingQuery) {
            this.user = new GlobalParticipant(participantBookingQuery.user);
            this.relevantExecutions = participantBookingQuery.relevant_executions.map((relevantEexecution) => new RelevantExecution(relevantEexecution));
        }
    }
}
